import { FestivalRoundButton } from "../../../../style";
import { FestivalSkeletonWhiteBox } from "../../../../style/skeleton";
import {
  FestivalMainCompetitionButton,
  FestivalMainCompetitionHeader,
  FestivalMainCompetitionHeaderRound,
  FestivalMainCompetitionSkeletonWrapper,
  FestivalMainCompetitionSwiperItem,
  FestivalMainCompetitionSwiperWrapper,
  FestivalMainCompetitionWrapper,
} from "./style";

const RabbitFestivalMainCompetitionSkeleton = () => {
  return (
    <FestivalMainCompetitionWrapper>
      <FestivalMainCompetitionHeader>
        <div className="title">토너먼트 정보</div>
        <FestivalRoundButton>
          더보기 <img src="/image-web/rabbit/right_arrow.svg" alt="arrow" />
        </FestivalRoundButton>
      </FestivalMainCompetitionHeader>
      <FestivalMainCompetitionSwiperWrapper>
        <FestivalMainCompetitionHeaderRound isTop={true} />
        <FestivalMainCompetitionSkeletonWrapper>
          <FestivalSkeletonWhiteBox width="16px" height="300px" />
          <FestivalMainCompetitionSwiperItem>
            <FestivalSkeletonWhiteBox width="100%" height="300px" />
          </FestivalMainCompetitionSwiperItem>
          <FestivalSkeletonWhiteBox width="16px" height="300px" />
        </FestivalMainCompetitionSkeletonWrapper>
        <FestivalMainCompetitionButton>
          <div className="button" />
        </FestivalMainCompetitionButton>
        <FestivalMainCompetitionHeaderRound isTop={false} />
      </FestivalMainCompetitionSwiperWrapper>
    </FestivalMainCompetitionWrapper>
  );
};

export default RabbitFestivalMainCompetitionSkeleton;
